module.exports = __webpack_public_path__ + "img/asuparticipax2.5bb9a99e.png";